export default "__VITE_ASSET__BV28LHOa__"